// extracted by mini-css-extract-plugin
export default {"container":"BuyPremium_container__QW42q"};